import React, { useEffect, useState } from "react";
import { Card, Box, Typography, CircularProgress } from "@mui/material";
import { DashboardApi } from "../../../api/DashboardApi";
import OrganizationLocationMap from "./OrganizationLocationMap";

function addExtraLocationData(orgs) {
    // For known orgs, we can add extra data like icon or corrected lat/lng here
    const extraList = [
        // {
        //     "id": "1000",
        //     "name_en": "THEI - Technological and Higher Education Institute of Hong Kong",
        //     "name_zh": "香港高等教育科技學院",
        //     "type": "school",
        //     "code": "thei",
        //     "pin_icon": "",
        //     "lat": "22.269928542411666",
        //     "lng": "114.2405956848004"
        //     // 22.269808743975332, 114.24053159485511
        // },
        // {
        //     "id":"1001",
        //     "name_en": "GO PARK Sai Sha",
        //     "name_zh": "西沙Go Park",
        //     "type": "etc",
        //     "code": "gopark",
        //     "pin_icon": "gopark",
        //     "lat": "22.4267644",
        //     "lng": "114.2650812"
        // }, 
        // {
        //     "id":"1002",
        //     "name_en": "Marriott Ocean Park",
        //     "name_zh": "香港海洋公園萬豪酒店",
        //     "type": "etc",
        //     "code": "marriott",
        //     "pin_icon": "marriott",
        //     "lat": "22.247455",
        //     "lng": "114.1757339"
        // },
        // {
        //     "id":"1003",
        //     "name_zh":"鵬程慈善基金",
        //     "name_en":"Bright Future Charitable Foundation",
        //     "type": "etc",
        //     "code":"brightfuture",
        //     "pin_icon":"brightfuture",
        //     "lat":"22.28104052144674",
        //     "lng":"114.17365005826505"
        // }
    ]

    for (let extra of extraList) {
        orgs.push(extra);
    }
    return orgs;
}

export default function UsageMapPanel() {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                let result = await DashboardApi.getOrganizationList();
                result = addExtraLocationData(result);
                console.log("Fetched organization list", result);
                setOrganizations(result ?? []);
            } catch (err) {
                console.error("Failed to fetch organization list", err);
                setError("Failed to load organization data.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrganizations();
        // setOrganizations([
        //      {
        //         "id": "11",
        //         "name_en": "Ho Shun Primary School ",
        //         "name_zh": "嗇色園主辦可信學校",
        //         "lat": "22.379814800380046",
        //         "lng": "114.13410300754266"
        //     },
        //     {
        //         "id": "139",
        //         "name_en": "Kei Tsz Primary School",
        //         "name_zh": "中華基督教會基慈小學",
        //         "lat": "22.350019305325546",
        //         "lng": "114.19639660760684"
        //     },

        //     {
        //         "id": "0",
        //         "name_en": "THEI - Technological and Higher Education Institute of Hong Kong",
        //         "name_zh": "香港高等教育科技學院",
        //         "icon" : "thei.png",
        //         "lat": "22.22.269928542411666",
        //         "lng": "114.2405956848004"
        //     },
        //     {
        //         "id": "143",
        //         "name_en": "Lam Tai Fai College",
        //         "name_zh": "林大輝中學",
        //         "lat": null,
        //         "lng": null
        //     },
        // ]);
        // setLoading(false);
    }, []);

    return (
        <Card variant="outlined" sx={{
            height: "100%", borderRadius: 0,
            display: "flex", flexDirection: "column", backgroundColor: "black",
        }}>
            <Box sx={{ px: 2, pb: 2, flex: 1, minHeight: 0 }}>
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Typography color="error">{error}</Typography>
                    </Box>
                ) : (
                    <OrganizationLocationMap organizations={organizations} />
                )}
            </Box>
        </Card>
    );
}